import { render, staticRenderFns } from "./TabsPitches.vue?vue&type=template&id=67655342"
import script from "./TabsPitches.vue?vue&type=script&lang=js"
export * from "./TabsPitches.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports